import useSWR from 'swr'

import { ProductSubscription } from '@livechat/design-system-react-components/dist/components/ProductSwitcher/types'

import { config } from 'lib/config'

export function useOrganizationSubscriptions() {
	const { data, isLoading, error } = useSWR<{ subscriptions: ProductSubscription }>(
		`${config.billingURL}/v3/subscriptions`,
		{
			revalidateIfStale: false,
			revalidateOnFocus: false,
			revalidateOnReconnect: false,
		},
	)

	return {
		organizationSubscriptions: data,
		areOrganizationSubscriptionsLoading: isLoading,
		organizationSubscriptionsError: error,
	}
}
